import React from 'react'
import { CategoryTitle, PropertyFeatures } from 'components'

const Features = ({ features, propertyName }) => {
  if (!features.length) {
    return null
  }

  const typeProperty = name =>
    (name && /Casa/i.test(name)) || (name && /Apartamento/i.test(name))

  return (
    <section>
      <CategoryTitle icon="characteristics" title="Características" />
      <PropertyFeatures
        isHouseApartment={typeProperty(propertyName)}
        allFeatures={features}
      />
    </section>
  )
}

export default Features
